import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../styles';

const useStyles = createUseStyles(
  ({ spacing }: ITheme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },

    content: {
      width: 295,
      height: 256,
      margin: spacing.large,
      padding: spacing.large,
      borderRadius: spacing.medium,
      background: 'var(--x-bg-1)',
      boxShadow: '0 0 4px 0 var(--x-shadow-card)',
    },

    logo: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: spacing.large,
    },
  }),
  {
    name: 'widget-card',
  },
);

export default useStyles;
